import { Link } from 'react-router-dom';

export default function About() {
  return (
    <div className="min-h-screen bg-[#1a1a2e] text-white font-['Orbitron'] flex flex-col">
      {/* Header */}
      <header className="p-4 flex items-center border-b border-white/10">
        <Link 
          to="/" 
          className="flex items-center gap-2 text-[#fbbf24] hover:text-[#f59e0b] transition-colors cursor-pointer"
        >
          <i className="ri-arrow-left-line text-xl"></i>
          <span className="text-sm">홈으로</span>
        </Link>
      </header>

      {/* Content */}
      <main className="flex-1 overflow-y-auto px-6 py-8 pb-safe">
        <div className="max-w-2xl mx-auto">
          <h1 className="text-3xl font-bold text-[#fbbf24] mb-8">About</h1>
          
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-[#fbbf24] mb-4">핀볼식스란?</h2>
            <p className="text-gray-300 leading-relaxed mb-4">
              핀볼식스(PinballSix)는 핀볼 게임을 통해 숫자를 생성하는 재미용 서비스입니다.
            </p>
            <p className="text-gray-300 leading-relaxed mb-4">
              단순한 랜덤 버튼이 아니라 물리 엔진 기반의 핀볼 게임을 통해 예측할 수 없는 번호가 만들어집니다.
            </p>
            <p className="text-gray-300 leading-relaxed">
              공을 발사하면 핀볼이 범퍼와 장애물을 지나 1부터 45까지의 번호 바구니 중 하나에 들어가며,
              총 6개의 번호가 모이면 자동으로 정렬되어 결과가 완성됩니다.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-[#fbbf24] mb-4">제작 목적</h2>
            <p className="text-gray-300 leading-relaxed mb-4">
              번호를 선택하는 일은 늘 고민이 됩니다.
            </p>
            <p className="text-gray-300 leading-relaxed">
              이 서비스는 그런 고민을 재미있는 게임 경험으로 바꿔줍니다.
              단순히 버튼으로 번호를 받는 것이 아니라, 공을 발사하고 움직임을 지켜보는 과정 자체를 즐길 수 있습니다.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-[#fbbf24] mb-4">사용 방법</h2>
            <div className="space-y-4">
              {[
                { step: '1', title: '게임 시작', desc: '"게임 시작" 버튼을 눌러 핀볼 게임을 시작합니다.' },
                { step: '2', title: '공 발사', desc: '플런저를 드래그해 힘을 조절하고 공을 발사합니다.' },
                { step: '3', title: '번호 수집', desc: '공이 번호 바구니에 들어가면 해당 번호가 선택됩니다. 총 6개의 번호를 모으면 결과가 완성됩니다.' },
                { step: '4', title: '결과 확인 및 공유', desc: '완성된 번호는 자동으로 정렬되며 이미지로 저장하거나 공유할 수 있습니다.' },
              ].map(({ step, title, desc }) => (
                <div key={step} className="flex gap-4 items-start">
                  <div className="w-8 h-8 rounded-full bg-[#fbbf24] text-[#1a1a2e] flex items-center justify-center font-bold text-sm shrink-0">
                    {step}
                  </div>
                  <div>
                    <p className="text-white font-semibold mb-1">{title}</p>
                    <p className="text-gray-300 leading-relaxed text-sm">{desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-[#fbbf24] mb-4">기술 정보</h2>
            <p className="text-gray-300 leading-relaxed mb-3">
              PinballSix는 <span className="text-[#fbbf24] font-semibold">Matter.js</span> 물리 엔진을 사용해 실제 핀볼과 유사한 움직임을 구현했습니다.
            </p>
            <p className="text-gray-300 leading-relaxed">
              번호는 물리 기반 움직임에 따라 완전히 랜덤하게 생성됩니다.
            </p>
          </section>
        </div>
      </main>
    </div>
  );
}